/* eslint-disable react/no-unescaped-entities */
import React, { useCallback, useContext, useEffect, useMemo } from 'react';
import { Modal, Button, Popover, Spin, message, Checkbox } from 'antd';
import s from './s.module.less';
import {
    KlarityService,
    ServerKlarityService,
    ServerMeta,
    TKlarityProgramItem,
    TKlarityProgramItemDetail,
    EServiceType,
} from 'types/common';
import { saveProviderKlarityService } from 'api/klarityService';
import { saveOpsProviderKlarityService } from 'api/operation';
import commonS from 'styles/common.module.less';
import SelectSpecialty from '../SelectSpecialty';
import ConfigService from '../ConfigService';
import ProgramConfigNote from '../ProgramConfigNote';
import SignProgram from '../SignProgram';
import { EModalMode, ServerData } from '../../types';
import { PracitceAddressForm } from 'types/practiceFront';
import { updateStepForm } from 'api/applicationForm';
import useInsuranceBillingStatus from 'hooks/useInsuranceBillingStatus';
import { getHasDisableViewServiceCheck, setHasDisableViewServiceCheck } from 'utils/localstore';
import UniprofileStepDataStore from 'store/UniprofileStepData';
import { Provider, UniprofileFormData } from 'types/provider';
import ProviderStore from 'store/Provider';
import {
    BOOK_PROGRAM_WEBINAR_LINK,
    KLAIRTY_TEMPLATE_PRICE_MAP,
    LA_FIRE_SPE_NAME,
    WEIGHT_LOSS_15_MINS_TEMPLATE,
} from 'constants/common';
import {
    setClickSkipWebinar,
    getClickSkipWebinar,
    getConfigingProgramId,
    getConfigProgramFromTable,
    setConfigProgramFromTable,
    setConfigingProgramId,
} from 'utils/sessionStorage';
import useKlarityProgram from 'hooks/useKlarityProgram';
import { enrollKlarityProgram, getKlarityProgramDetail, TEnrollKlarityProgram } from 'api/common';
import { IInsurance } from 'types/insurance';
import { FunctionContext } from 'utils/functionContext';
import { ISpecialtiesOptions } from 'types/applicationForm';
import { useNavigate } from 'react-router-dom';
import { PATH } from 'constants/path';
import { validationForInsuranceTable } from 'utils/serviceTemplate';
import useProviderHomeInfo from 'hooks/useProviderHomeInfo';

type IProps = {
    onCancel: (hasChange: boolean) => void;
    recommendData?: KlarityService[];
    otherData?: KlarityService[];
    onSelected: (data: KlarityService[]) => void;
    mode?: EModalMode;
    allowStatesForService?: ServerMeta[];
    editData?: KlarityService[]; //under config
    fetchingEdit?: boolean;
    editingValue?: ServerKlarityService[];
    isEdit?: boolean;
    isOps?: boolean;
    // 运营端需要传当前操作的用户id
    providerId?: number;
    // showTypeCheckbox?: boolean;
    showEditButtons?: boolean;
    addressList?: PracitceAddressForm[];
    onBack?: () => void;
    isReviewStep?: boolean;
    hideFooter?: boolean;
    targetSpecialty?: string;
    isKiwiUser?: boolean;
    uniprofileInsuranceData?: IInsurance[];
    serverIdStateMap: Record<string, ServerMeta[]>;
    setServerIdStateMap: (data: Record<string, ServerMeta[]>) => void;
    allPrograms: TKlarityProgramItem[];
    refetchProgram: () => void;
    provider?: UniprofileFormData;
    nextBtnText?: string;
    footWrapCalss?: string;
    onSetCurrentStep?: (v: EModalMode) => void;
    hideAvaTip?: boolean;
    setIsSpecialtyiesEnd?: (v: boolean) => void;
    isServiceSetting?: boolean;
    fullWidthFooter?: boolean;
    isPPVOPS?: boolean;
};

// EModalMode.CONFIG_PROGRAM_NOTE
const ServiceLayer = (props: IProps) => {
    const {
        hideFooter,
        recommendData,
        otherData,
        editData,
        isReviewStep,
        onBack,
        onCancel,
        onSelected,
        mode,
        allowStatesForService = [],
        addressList,
        editingValue,
        isEdit,
        isOps,
        providerId,
        targetSpecialty,
        isKiwiUser,
        uniprofileInsuranceData,
        setServerIdStateMap,
        serverIdStateMap,
        allPrograms,
        refetchProgram,
        provider: uniprofileProvider,
        nextBtnText = 'Next',
        footWrapCalss = '',
        onSetCurrentStep,
        hideAvaTip,
        setIsSpecialtyiesEnd,
        isServiceSetting,
        fullWidthFooter = false,
        isPPVOPS,
    } = props;
    const navigate = useNavigate();
    const footerWidth = isServiceSetting ? '100%' : 'auto';
    // 用于确认数据来源，根据以前的业务逻辑，只要isEdit或者iskiwiUser的话，这个layer默认都是拿取editData，但是现在还有一种情况，就是从ServiceSetting页面进入，这时候不是isEdit,并且是kiwiuser，所以editData是undefined，但是要用selectData
    // 目前传的值是isServiceSetting， 后续如果还有选择kiwiuser，但是layer是从specialtySelected进入的，那么需要传true
    const getCurrentEditDataFromSpecialtySelected = isServiceSetting;
    const [currentStep, setCurrentStep] = React.useState<EModalMode>(mode || EModalMode.CONFIG_SERVICE);
    const [selectData, setSelectData] = React.useState<KlarityService[]>([]); //mockSelectedServiceData
    // const [serverIdStateMap, setServerIdStateMap] = React.useState<Record<string, ServerMeta[]>>({});
    const [currentSettingServiceTypeInx, setCurrentSettingServiceTypeInx] = React.useState<number>(1);
    const [pendingSaveData, setPendingSaveData] = React.useState<ServerData>();
    const [hasSaveAny, setHasSaveAny] = React.useState<boolean>(false);
    const [hasNameError, setHasNameError] = React.useState<boolean>(false);
    const [saving, setSaving] = React.useState<boolean>(false);
    const [showTipsModal, setShowTipsModal] = React.useState(false);
    const [hasCheckNotShow, setHasCheckNotShow] = React.useState(false);
    const [showWebinarModal, setShowWebinarModal] = React.useState(false);
    const [signChecked, setSignChecked] = React.useState(false);
    const [getProvider] = ProviderStore.useStore();
    const provider: Provider = getProvider('data') as Provider;
    const [onAgreeButtonClickFlag, setOnAgreeButtonClickFlag] = React.useState<{}>();
    const [configingProgram, setConfigingProgram] = React.useState<TKlarityProgramItemDetail>();
    const [fetchingProgram, setFetchingProgram] = React.useState<boolean>(false);
    const [enrolling, setEnrolling] = React.useState<boolean>(false);
    const [errorMedicationFlag, setErrorMedicationFlag] = React.useState<{}>();
    const [isEditingConditions, setIsEditingConditions] = React.useState<boolean>(false);
    const [homeInfo] = useProviderHomeInfo();
    // 只有真正的 PPV（后端 ppvProvider）才算 PPV；没有 vendor mapping 的 EHR Only / billing 起步用户不能再按「非 PPA」当成 PPV
    const isPPV = !!homeInfo?.ppvProvider;

    const [get, set] = UniprofileStepDataStore.useStore();
    const configSpeciality = get('speciality');
    const currentSpeciality = get('currentSpeciality');
    const specialityWithProgram = allPrograms.find((item) => item.specialtyName === currentSpeciality);

    const hasDisableViewServiceCheck = isKiwiUser ? true : getHasDisableViewServiceCheck();

    const allowStateRemovedNotSupport = allowStatesForService?.filter((item) => {
        const notSupportStates = configingProgram?.excludeState?.split(',') || [];
        return notSupportStates.indexOf(item.dictKey) === -1;
    });

    const hasAnySupportState = allowStateRemovedNotSupport && allowStateRemovedNotSupport?.length > 0;
    const isConfigLaFire = currentSpeciality?.toLowerCase() === LA_FIRE_SPE_NAME?.toLowerCase();

    const useInsuranceComponent = isOps && !isPPVOPS;
    const [insuranceBillingStatus] = useInsuranceBillingStatus();

    // console.log({
    //     pendingSaveData,
    // });

    //console.log(JSON.stringify(serverIdStateMap))

    //console.log(JSON.stringify(selectData))

    const selectDataLength =
        !getCurrentEditDataFromSpecialtySelected && isKiwiUser ? editData?.length : selectData?.length;
    // 如果只是作为弹出框作用，那么应该需要从外部传入setSelectData，然后给到这的configService组件
    const currentEditData = !getCurrentEditDataFromSpecialtySelected && (isEdit || isKiwiUser) ? editData : selectData;

    const showSkip = useMemo(() => {
        // if (disableSkipOnlyOneSpecialty) {
        //     return selectDataLength && selectDataLength > 1;
        // }
        return currentSettingServiceTypeInx <= (selectDataLength || 0);
    }, [selectDataLength, currentSettingServiceTypeInx]);

    React.useEffect(() => {
        //todo remove
        //set("currentSpeciality", "Infections");
        //setCurrentStep(EModalMode.CONFIG_PROGRAM_NOTE);
        //setConfigingProgram(mockConfigProgramDetail);
    }, [allPrograms]);

    React.useEffect(() => {
        if (mode) {
            setCurrentStep(mode);
        }
    }, [mode]);

    React.useEffect(() => {
        onSetCurrentStep?.(currentStep);
    }, [currentStep]);

    const { setChildFunction } = useContext(FunctionContext);

    const handleBack = useCallback(() => {
        let isBackOver = false;
        const prevStep = currentSettingServiceTypeInx - 1;
        if (prevStep > 0) {
            setCurrentSettingServiceTypeInx(prevStep);
        } else {
            isBackOver = true;
            onCancel?.(hasSaveAny);
            set('currentSpeciality', undefined);
            set('speciality', []);
        }
        scrollToTop();
        return isBackOver;
    }, [hasSaveAny, currentSettingServiceTypeInx]);

    useEffect(() => {
        setChildFunction({
            back: handleBack,
            setStep: (v: EModalMode) => {
                setCurrentStep(v);
            },
        });
    }, [handleBack, setCurrentStep]);

    const handleSkip = () => {
        removeSpecialtyParameter();
        const nextInx = currentSettingServiceTypeInx + 1;
        const isEnd = nextInx > (currentEditData?.length || 0);
        if (isEnd) {
            onCancel?.(hasSaveAny);
            set('currentSpeciality', undefined);
            set('speciality', []);
            scrollToTop();
            if (isServiceSetting) {
                setIsSpecialtyiesEnd?.(true);
            }
            return;
        }
        setCurrentSettingServiceTypeInx(nextInx);
        scrollToTop();
        //onCancel?.(hasSaveAny);
    };

    const scrollToTop = () => {
        if (isReviewStep) {
            const target = document.getElementById('layer-wrap');
            try {
                target?.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                });
            } catch (e) {
                console.error(e);
            }
            return;
        }
        try {
            // document.getElementsByClassName('ant-modal-body')[0].scrollTo({
            //     top: 0,
            //     behavior: 'smooth',
            // });
            document.getElementById('ks-form-content')?.scrollTo({
                top: 0,
                behavior: 'smooth',
            });
        } catch (e) {
            console.error(e);
        }
    };

    const scrollIntoEmtpyMedication = () => {
        setTimeout(() => {
            try {
                const target = document.getElementsByClassName('emptyMedication');
                if (target && target.length > 0) {
                    target[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            } catch (e) {
                console.error(e);
            }
        }, 400);
    };

    const updateUniprofile = async () => {
        try {
            const submitData = {
                step: 'KLARITY_SERVICES',
            };

            const result = await updateStepForm(submitData);

            if (result?.error) {
                message.error(result.error);
            }
        } catch (e) {
            console.error(e);
        }
    };

    const actionFunc = async (programId?: string) => {
        const configProgramId = programId || getConfigingProgramId();
        if (configProgramId) {
            const detailResult = await getKlarityProgramDetail(parseInt(configProgramId, 10));
            if (!detailResult.error) {
                const detail = detailResult?.data?.data;
                setConfigingProgram(detail);
                setCurrentStep(EModalMode.CONFIG_PROGRAM_NOTE);
                scrollToTop();
            }
        }
    };

    React.useEffect(() => {
        actionFunc();
    }, []);

    // const handleCancel = () => {
    //     () => {
    //         setCurrentStep(mode || EModalMode.SELECT_SPECIALTY);
    //         setSelectData([]);
    //         setCurrentSettingServiceTypeInx(1);
    //         setServerIdStateMap({});
    //         onCancel?.(hasSaveAny);
    //     }
    // }

    // const handleOpenCalendar = () => {
    //     setShowWebinarModal(false);
    //     try {
    //         const objString = new URLSearchParams({
    //             hide_gdpr_banner: '1',
    //             first_name: provider?.firstName,
    //             last_name: provider?.lastName
    //         }).toString();
    //         (window as any).Calendly.initPopupWidget({
    //             url: `${BOOK_APPOINTMENT_LINK}?${objString}`,
    //             prefill: {
    //                 email: provider?.email,
    //             },
    //         });

    //     } catch (err) {
    //         console.log(err)
    //     } finally {
    //         setShowWebinarModal(false);
    //     }
    // }
    const handleOpenCalendarInModal = () => {
        setShowWebinarModal(true);
        setTimeout(() => {
            const objString = new URLSearchParams({
                hide_gdpr_banner: '1',
                first_name: provider?.firstName,
                last_name: provider?.lastName,
            }).toString();

            (window as any).Calendly.initInlineWidget({
                url: `${BOOK_PROGRAM_WEBINAR_LINK}?${objString}`,
                // url: `https://calendly.com/kunqian-fan/11?${objString}`,
                parentElement: document.getElementById('calendly'),
                prefill: {
                    email: provider?.email,
                },
            });
        }, 300);
    };

    const removeSpecialtyParameter = () => {
        // 获取当前页面的 URL
        const url = new URL(window.location.href);
        // 获取查询参数
        const params = new URLSearchParams(url.search);

        // 检查并移除 'specialty' 参数
        if (params.has('specialty')) {
            params.delete('specialty');

            // 更新 URL 的查询字符串
            url.search = params.toString();

            // 使用 history.replaceState 替换当前历史记录条目
            history.replaceState(null, '', url.toString());
        }
    };

    // kiwi service PatientCost是手动填写的了，所以要校验下。
    const checkNonePatientCost = (pendingSaveDataParam?: ServerData) => {
        if (isKiwiUser && pendingSaveDataParam && pendingSaveDataParam.providerKlarityService) {
            const hasPatientCostIsNull = pendingSaveDataParam.providerKlarityService.find((item) =>
                item.serviceStateItems.find(
                    (stateItem) => !stateItem.patientCost && typeof stateItem.patientCost !== 'number',
                ),
            );

            if (hasPatientCostIsNull) {
                message.error(
                    `${hasPatientCostIsNull.serviceType} has no patient cost in ${hasPatientCostIsNull.serviceSpecialtyName}`,
                    6,
                );
                return true;
            }
        }
        return false;
    };

    const checkPaymentType = (pendingSaveDataParam?: ServerData) => {
        if (isKiwiUser && pendingSaveDataParam && pendingSaveDataParam.providerKlarityService) {
            const hasPaymentTypeIsNull = pendingSaveDataParam.providerKlarityService.find(
                (item) => !item.cashPay && !item.insurancePay,
            );
            if (hasPaymentTypeIsNull) {
                message.error(
                    `${hasPaymentTypeIsNull.serviceType} has no payment type in ${hasPaymentTypeIsNull.serviceSpecialtyName}`,
                    6,
                );
                return true;
            }
        }
        return false;
    };

    const checkWithoutState = (pendingSaveDataParam?: ServerData) => {
        if (isKiwiUser && pendingSaveDataParam && pendingSaveDataParam.providerKlarityService) {
            const hasWithoutState = pendingSaveDataParam.providerKlarityService.find(
                (item) => item.serviceStateItems.length === 0,
            );
            if (hasWithoutState) {
                message.error(
                    `${hasWithoutState.serviceType} has no state in ${hasWithoutState.serviceSpecialtyName}`,
                    6,
                );
                return true;
            }
        }
        return false;
    };

    const checkServerItemStatesAllInInsurance = (item?: ServerKlarityService) => {
        if (isKiwiUser && item) {
            const statesInServerItem = item.serviceStateItems.map((stateItem) => stateItem.state);
            const statesInInsurance = item.insurances.map((insurance) => insurance.state);
            return statesInServerItem.find((state) => !statesInInsurance.includes(state));
        }
        return false;
    };

    const checkInsurance = (pendingSaveDataParam?: ServerData) => {
        if (isKiwiUser && pendingSaveDataParam && pendingSaveDataParam.providerKlarityService) {
            const hasInsurance = pendingSaveDataParam.providerKlarityService.find((item) => {
                if (
                    item.insurancePay &&
                    !item.cashPay &&
                    (!item.insurances ||
                        item.insurances.length === 0 ||
                        item.insurances.find((ins) => !ins.carrier) ||
                        checkServerItemStatesAllInInsurance(item))
                ) {
                    return true;
                }
                return false;
            });

            if (hasInsurance) {
                message.error(
                    `Please select at least one carrier if you only choose insurance as the payment method in ${hasInsurance.serviceType}`,
                    6,
                );
                return true;
            }
        }
        return false;
    };

    const handleSaveService = async () => {
        if (isEditingConditions) {
            message.error('Please save the conditions.');
            window?.scrollTo({
                top: 0,
                behavior: 'smooth',
            });
            return;
        }
        if (!currentEditData) {
            return;
        }
        const checkResult = checkNonePatientCost(pendingSaveData);
        const checkPaymentTypeResult = checkPaymentType(pendingSaveData);
        const checkWithoutStateResult = checkWithoutState(pendingSaveData);
        const checkInsuranceResult = checkInsurance(pendingSaveData);

        if (checkResult || checkPaymentTypeResult || checkWithoutStateResult || checkInsuranceResult) {
            return;
        }

        if (isKiwiUser) {
            const serviceData = pendingSaveData?.providerKlarityService;
            if (useInsuranceComponent && serviceData) {
                const res = validationForInsuranceTable(serviceData);

                if (!res.isValid) {
                    res.errors.forEach((error) => {
                        message.error(error);
                    });
                    return;
                }
                serviceData.forEach((item) => {
                    const { insurancePay } = item;
                    if (!insurancePay) {
                        item.insurances = [];
                    }
                });
            } else {
                let isValidInsurance = true;
                const servicesDidNotSetInsurance: string[] = [];
                if (serviceData && serviceData.length > 0) {
                    serviceData.forEach((item) => {
                        if (item.insurancePay && !item.cashPay) {
                            if (!item.insurances || item.insurances.length === 0) {
                                isValidInsurance = false;
                                servicesDidNotSetInsurance.push(item.serviceType);
                            }
                        }
                    });
                }

                if (!isValidInsurance) {
                    message.error(
                        `Please set insurance for the following services: ${servicesDidNotSetInsurance.join(', ')}`,
                    );
                    return;
                }
            }
        }

        removeSpecialtyParameter();
        const nextInx = currentSettingServiceTypeInx + 1;
        const max = currentEditData.length + 1;
        const _emptyMedicationErrorIndex = [];
        const length = pendingSaveData?.providerKlarityService?.length || 0;

        for (let i = 0; i < length; i++) {
            const service = pendingSaveData?.providerKlarityService[i];
            const isMedication = service?.serviceType === EServiceType.MEDICATIONS;
            if (isMedication) {
                const medLength = service?.medications?.length || 0;
                if (medLength === 0) {
                    _emptyMedicationErrorIndex.push(i);
                }
            }
        }
        const hasEmptyMedication = _emptyMedicationErrorIndex.length > 0;
        if (hasEmptyMedication) {
            setErrorMedicationFlag(_emptyMedicationErrorIndex?.length > 0 ? {} : undefined);
            scrollIntoEmtpyMedication();
            message.error('Please select at least one medication for each medication service.');
            return;
        }

        for (let i = 0; i < length; i++) {
            const service = pendingSaveData?.providerKlarityService[i];
            const cpts = service?.cpts;
            if (cpts && cpts.length > 0) {
                const hasIncomplete = cpts.some((cpt) => !cpt.description?.trim() || !cpt.insuranceRate);
                if (hasIncomplete) {
                    message.error('Please fill in Description and Insurance rate for all billing codes');
                    return;
                }
            }
        }

        if (insuranceBillingStatus?.onboardingCompleted) {
            for (let i = 0; i < length; i++) {
                const service = pendingSaveData?.providerKlarityService[i];
                const cpts = service?.cpts;
                const hasCompleteCpt = cpts?.some(
                    (cpt) => cpt.cptCode?.trim() && cpt.description?.trim() && cpt.insuranceRate,
                );
                if (!hasCompleteCpt && !isPPV) {
                    message.error(
                        'At least one complete billing code with Insurance rate is required for each service.',
                    );
                    return;
                }
            }
        }

        const providerKlarityServiceData = pendingSaveData?.providerKlarityService?.map((e) => {
            if (e.klarityTemplate === WEIGHT_LOSS_15_MINS_TEMPLATE) {
                return {
                    ...e,
                    serviceStateItems: e.serviceStateItems?.map((e) => {
                        return {
                            ...e,
                            duration: KLAIRTY_TEMPLATE_PRICE_MAP[WEIGHT_LOSS_15_MINS_TEMPLATE]?.duration,
                            earning: KLAIRTY_TEMPLATE_PRICE_MAP[WEIGHT_LOSS_15_MINS_TEMPLATE]?.myEarning,
                            marketingMarkup: KLAIRTY_TEMPLATE_PRICE_MAP[WEIGHT_LOSS_15_MINS_TEMPLATE]?.marketingMarkUp,
                            patientCost: KLAIRTY_TEMPLATE_PRICE_MAP[WEIGHT_LOSS_15_MINS_TEMPLATE]?.patientCost,
                            platformFee: KLAIRTY_TEMPLATE_PRICE_MAP[WEIGHT_LOSS_15_MINS_TEMPLATE]?.platformFee,
                        };
                    }),
                };
            }

            return e;
        });

        if (nextInx === max) {
            //finish
            setSaving(true);
            let result: any = {};
            if (isOps && providerId) {
                result = await saveOpsProviderKlarityService(
                    providerId,
                    providerKlarityServiceData || [],
                    pendingSaveData?.disableIds || [],
                    pendingSaveData?.conditions,
                );
            } else {
                await updateUniprofile();
                result = await saveProviderKlarityService(
                    providerKlarityServiceData || [],
                    pendingSaveData?.disableIds || [],
                    pendingSaveData?.conditions || [],
                );
            }

            if (!result.error) {
                //success
                onCancel?.(true);
                set('currentSpeciality', undefined);
                set('speciality', []);
                setIsSpecialtyiesEnd?.(true);
            }
            setSaving(false);
        } else {
            //do save,
            setSaving(true);
            let result: any = {};
            if (isOps && providerId) {
                result = await saveOpsProviderKlarityService(
                    providerId,
                    providerKlarityServiceData || [],
                    pendingSaveData?.disableIds || [],
                    pendingSaveData?.conditions,
                );
            } else {
                await updateUniprofile();
                result = await saveProviderKlarityService(
                    providerKlarityServiceData || [],
                    pendingSaveData?.disableIds || [],
                    pendingSaveData?.conditions || [],
                );
            }
            if (!result.error) {
                //success
                const serviceIds = result?.data?.data;
                if (currentEditData && currentEditData[currentSettingServiceTypeInx - 1] && serviceIds) {
                    currentEditData[currentSettingServiceTypeInx - 1].savedValue = providerKlarityServiceData;
                    currentEditData[currentSettingServiceTypeInx - 1].savedValue?.forEach((item, inx) => {
                        if (serviceIds.length > inx) {
                            item.serviceId = serviceIds[inx];
                        }
                    });
                }
                setCurrentSettingServiceTypeInx(nextInx);
                const targetSpe =
                    nextInx < currentEditData?.length ? currentEditData[nextInx]?.specialtyName : undefined;
                const withProgram = allPrograms.find(
                    (item) => item.specialtyName?.toLowerCase() === targetSpe?.toLowerCase(),
                );
                if (withProgram && !withProgram.enrolled) {
                    const detailResult = await getKlarityProgramDetail(withProgram.id);
                    if (!detailResult.error) {
                        const detail = detailResult?.data?.data;
                        console.log({
                            detail,
                        });
                        setConfigingProgram(detail);
                        set('currentSpeciality', targetSpe);
                        setCurrentStep(EModalMode.CONFIG_PROGRAM_NOTE);
                        scrollToTop();
                        setHasSaveAny(true);
                        setSaving(false);
                        return;
                    }
                }
                scrollToTop();
                setHasSaveAny(true);
            }
            setSaving(false);
        }
    };

    const handleNextForSelectService = async () => {
        const first = currentEditData && currentEditData.length > 0 ? currentEditData[0] : undefined;

        if (first) {
            const firstSpe = first?.specialtyName;
            const withProgram = allPrograms.find(
                (item) => item.specialtyName?.toLowerCase() === firstSpe?.toLowerCase(),
            );

            if (withProgram && !withProgram.enrolled) {
                setFetchingProgram(true);
                const detailResult = await getKlarityProgramDetail(withProgram.id);
                if (!detailResult.error) {
                    const detail = detailResult?.data?.data;
                    setConfigingProgram(detail);
                    set('currentSpeciality', firstSpe);
                    if (isKiwiUser) {
                        setCurrentStep(EModalMode.CONFIG_SERVICE);
                    } else {
                        setCurrentStep(EModalMode.CONFIG_PROGRAM_NOTE);
                    }
                    scrollToTop();
                    return;
                }
                setFetchingProgram(false);
            }
        }
        setCurrentStep(EModalMode.CONFIG_SERVICE);
        scrollToTop();
    };

    const handleSignProgram = async (submitData: TEnrollKlarityProgram) => {
        setEnrolling(true);
        const enrollResult = await enrollKlarityProgram(submitData);
        if (!enrollResult.error) {
            refetchProgram();
            if (getConfigProgramFromTable()) {
                setConfigProgramFromTable(false);
                setConfigingProgramId('');
                onBack?.();
                return;
            }
            setCurrentStep(EModalMode.CONFIG_SERVICE);
            scrollToTop();
        }
        setEnrolling(false);
    };

    React.useEffect(() => {
        if (
            (targetSpecialty &&
                allowStatesForService &&
                allowStatesForService.length > 0 &&
                recommendData &&
                recommendData.length > 0) ||
            (otherData && otherData.length > 0)
        ) {
            const isLaFireSpecialty = targetSpecialty?.toLowerCase() === LA_FIRE_SPE_NAME;
            const caState = allowStatesForService.find((item) => item.dictKey?.toLowerCase() === 'ca');
            let find = (recommendData || []).find(
                (item) => item.specialtyName?.toLowerCase() === targetSpecialty?.toLowerCase(),
            );
            if (!find) {
                find = (otherData || []).find(
                    (item) => item.specialtyName?.toLowerCase() === targetSpecialty?.toLowerCase(),
                );
            }
            if (find && isLaFireSpecialty && caState) {
                setSelectData([find]);
                onSelected?.([find]);
                set('speciality', [find.specialtyName]);
                setCurrentStep(EModalMode.CONFIG_SERVICE);
                setServerIdStateMap({
                    [find.id]: [caState],
                });
            } else if (find) {
                setSelectData([find]);
                onSelected?.([find]);
                set('speciality', [find.specialtyName]);
                setCurrentStep(EModalMode.CONFIG_SERVICE);
                setServerIdStateMap({
                    [find.id]: allowStatesForService,
                });
            }
        }
    }, [targetSpecialty, recommendData, otherData, allowStatesForService]);

    const configServiceFooter = () => {
        return fullWidthFooter ? (
            <div className={s.fullWidthFooter}>
                <div className={s.left}>
                    <Button
                        onClick={() => {
                            navigate(`${PATH.DASHBOARD}`);
                        }}
                    >
                        Exit
                    </Button>
                    <Button type="link" className={s.linkBtn} onClick={handleSkip}>
                        Skip
                    </Button>
                </div>
                <div className={s.right}>
                    <Button type="primary" loading={saving} onClick={handleSaveService}>
                        Next
                    </Button>
                </div>
            </div>
        ) : (
            <>
                <div className={s.left} />
                <div className={s.right}>
                    {showSkip ? (
                        <Button
                            style={{
                                width: '49%',
                            }}
                            onClick={handleSkip}
                        >
                            Skip
                        </Button>
                    ) : (
                        <span />
                    )}
                    {!showSkip && isEdit && (
                        <Button
                            style={{
                                width: '49%',
                            }}
                            onClick={() => {
                                onCancel?.(false);
                            }}
                        >
                            Cancel
                        </Button>
                    )}

                    <Button
                        style={{
                            width: '49%',
                            minWidth: '250px',
                        }}
                        onClick={() => {
                            if (!pendingSaveData?.allSeted && !hasDisableViewServiceCheck && !isEdit) {
                                setShowTipsModal(true);
                            } else {
                                handleSaveService();
                            }
                        }}
                        type="primary"
                        disabled={hasNameError}
                        loading={saving}
                    >
                        {hasNameError ? (
                            <Popover
                                content={
                                    hasNameError ? (
                                        <div className={s.toolWrap}>Please fix duplicate name error first</div>
                                    ) : null
                                }
                                trigger="hover"
                            >
                                {isConfigLaFire && !isKiwiUser ? 'Enroll the service' : 'Save services'}
                            </Popover>
                        ) : (
                            <span>{isConfigLaFire && !isKiwiUser ? 'Enroll the service' : 'Save services'}</span>
                        )}
                    </Button>
                </div>
            </>
        );
    };

    return (
        /**
         * SELECT_SPECIALTY 页面不需要处理paddingBottom，因为在Service setting这个页面，底部只有一个footer
         * config service页面有2个footer，所以需要处理paddingBottom
         */
        <div
            className={`${isServiceSetting ? s.paddingBottom : ''}`}
            id="layer-wrap"
            // style={currentStep !== EModalMode.SELECT_SPECIALTY && typeof footerBottom === 'number' ? { paddingBottom: `${footerBottom}px` } : {}}
        >
            {currentStep === EModalMode.SELECT_SPECIALTY && (
                <SelectSpecialty
                    // serverIdStateMap={serverIdStateMap}
                    // setServerIdStateMap={setServerIdStateMap}
                    hideAvaTip={hideAvaTip}
                    isKiwiUser={isKiwiUser}
                    isLayer
                    onSelectedDataChange={(data) => {
                        setSelectData(data);
                        onSelected?.(data);
                        set(
                            'speciality',
                            data?.map((item) => item.specialtyName),
                        );
                    }}
                    otherData={otherData}
                    recommendData={recommendData}
                    onServerIdStateMapChange={setServerIdStateMap}
                    allowStates={allowStatesForService}
                />
            )}
            {currentStep === EModalMode.CONFIG_SERVICE && (
                <ConfigService
                    isEditingConditions={isEditingConditions}
                    setIsEditingConditions={setIsEditingConditions}
                    provider={uniprofileProvider}
                    uniprofileInsuranceData={uniprofileInsuranceData}
                    isKiwiUser={isKiwiUser}
                    isEdit={isEdit}
                    onHasNameErrorUpdate={setHasNameError}
                    onUpdate={setPendingSaveData}
                    serviceDatas={currentEditData}
                    errorMedicationFlag={errorMedicationFlag}
                    editingValue={editingValue}
                    serverIdStateMap={serverIdStateMap}
                    currentEditingStep={currentSettingServiceTypeInx}
                    isOps={isOps}
                    programList={allPrograms}
                    isLayer
                    providerId={providerId}
                    addressList={addressList}
                    allStatesFromService={allowStatesForService}
                    handleExploreProgram={() => {
                        const firstSpe = 'Weight Loss';
                        const withProgram = allPrograms.find(
                            (item) => item.specialtyName?.toLowerCase() === firstSpe?.toLowerCase(),
                        );

                        if (withProgram && !withProgram.enrolled) {
                            actionFunc(withProgram.id.toString());
                        } else {
                            message.error('No program selected. Please try again.');
                        }
                    }}
                    useInsuranceComponent={useInsuranceComponent}
                />
            )}
            {currentStep === EModalMode.CONFIG_PROGRAM_NOTE && <ProgramConfigNote data={configingProgram} isLayer />}
            {currentStep === EModalMode.SIGN_PROGRAM && (
                <SignProgram
                    onAgreeButtonClickFlag={onAgreeButtonClickFlag}
                    data={configingProgram}
                    allowStates={allowStatesForService}
                    onSuccessNext={handleSignProgram}
                />
            )}
            {!hideFooter && (
                <div
                    // style={typeof footerBottom === 'number' ? { bottom: `${footerBottom}px` } : {}}
                    className={`
                            ${s.footWrap}
                            ${currentStep === EModalMode.SELECT_SPECIALTY ? footWrapCalss : ''} 
                            ${[EModalMode.CONFIG_PROGRAM_NOTE, EModalMode.CONFIG_PROGRAM, EModalMode.SIGN_PROGRAM, EModalMode.CONFIG_SERVICE].includes(currentStep) ? s.footWrapWhite : ''} 
                            ${isReviewStep ? s.footerInReview : ''} 
                            ${isKiwiUser ? s.footWrapKiwi : ''}
                            ${isServiceSetting && currentStep !== EModalMode.SELECT_SPECIALTY ? s.relative : ''}
                        `}
                    style={{
                        width: isServiceSetting && currentStep === EModalMode.SELECT_SPECIALTY ? footerWidth : 'auto',
                    }}
                >
                    {currentStep === EModalMode.SELECT_SPECIALTY && (
                        <>
                            <Button
                                className={`${s.back} backClass`}
                                onClick={() => {
                                    onBack?.();
                                }}
                            >
                                Back
                            </Button>
                            <Button
                                onClick={handleNextForSelectService}
                                type="primary"
                                className={`${s.next} nextClass`}
                                loading={fetchingProgram}
                                disabled={selectData.length === 0}
                            >
                                {nextBtnText}
                            </Button>
                        </>
                    )}
                    {!hideFooter && currentStep === EModalMode.CONFIG_PROGRAM_NOTE && (
                        <>
                            {getConfigProgramFromTable() && (
                                <Button
                                    className={s.cancelFromTable}
                                    onClick={() => {
                                        setConfigProgramFromTable(false);
                                        setConfigingProgramId('');
                                        onBack?.();
                                    }}
                                >
                                    Cancel
                                </Button>
                            )}
                            {/* {
                            !getConfigProgramFromTable() &&
                            <Button
                                className={s.skip}
                                onClick={() => {
                                    // setClickSkipWebinar(true);
                                    // handleOpenCalendarInModal();
                                    //handleOpenCalendar();
                                    setCurrentStep(EModalMode.CONFIG_SERVICE);
                                    scrollToTop();
                                }}
                            >
                                Skip
                            </Button>
                        } */}
                            <Button
                                className={s.viewVideo}
                                onClick={() => {
                                    // setClickSkipWebinar(true);
                                    // handleOpenCalendarInModal();
                                    window.open(
                                        'https://drive.google.com/drive/folders/11ESL1fh57tIoVZQ0qQZWjLh3rvWEEZTn?usp=drive_link',
                                        '_blank',
                                    );
                                    //handleOpenCalendar();
                                    //setCurrentStep(EModalMode.CONFIG_SERVICE);
                                    //scrollToTop();
                                }}
                            >
                                View program videos
                            </Button>

                            <Button
                                onClick={() => {
                                    setCurrentStep(EModalMode.SIGN_PROGRAM);
                                    if (document.getElementById('ks-form-content')) {
                                        const offsetTop = document.getElementById('ks-form-content')!.scrollTop;
                                        if (offsetTop > 100) {
                                            setTimeout(() => {
                                                scrollToTop();
                                            }, 200);
                                        }
                                    }
                                }}
                                type="primary"
                                className={s.next}
                            >
                                Enroll the program
                            </Button>
                        </>
                    )}
                    {currentStep === EModalMode.SIGN_PROGRAM && (
                        <>
                            <Button
                                className={s.back}
                                onClick={() => {
                                    setCurrentStep(EModalMode.CONFIG_PROGRAM_NOTE);
                                    scrollToTop();
                                }}
                            >
                                Back
                            </Button>
                            {!hasAnySupportState && (
                                <Button
                                    onClick={() => {
                                        if (getConfigProgramFromTable()) {
                                            setConfigProgramFromTable(false);
                                            setConfigingProgramId('');
                                            onBack?.();
                                            return;
                                        }
                                        setCurrentStep(EModalMode.CONFIG_SERVICE);
                                        scrollToTop();
                                    }}
                                    className={s.next}
                                >
                                    Skip the program due to state restrictions
                                </Button>
                            )}
                            {hasAnySupportState && (
                                <Button
                                    onClick={() => {
                                        setOnAgreeButtonClickFlag({});
                                    }}
                                    type="primary"
                                    loading={enrolling}
                                    className={s.next}
                                >
                                    Agree to enroll
                                </Button>
                            )}
                        </>
                    )}
                    {/* {
                    currentStep === EModalMode.CONFIG_PROGRAM &&
                    <>
                        <Button
                            className={s.back}
                            onClick={() => {
                                setCurrentStep(EModalMode.CONFIG_SERVICE);
                                scrollToTop();
                            }}
                        >
                            Skip the program
                        </Button>
                        <Button
                            onClick={() => {
                                setCurrentStep(EModalMode.CONFIG_SERVICE);
                                scrollToTop();
                            }}
                            type="primary"
                            className={s.next}
                        >
                            Next
                        </Button>
                    </>
                } */}
                    {currentStep === EModalMode.CONFIG_SERVICE && configServiceFooter()}
                </div>
            )}

            <Modal
                open={showTipsModal}
                footer={null}
                onCancel={() => {
                    setShowTipsModal(false);
                    setHasCheckNotShow(false);
                }}
            >
                <div>
                    <div className={s.confirmWrap}>
                        <div className={s.icon}>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                            >
                                <path
                                    d="M11.9995 9V11M11.9995 15H12.0095M5.07134 19H18.9277C20.4673 19 21.4296 17.3333 20.6598 16L13.7316 4C12.9618 2.66667 11.0373 2.66667 10.2675 4L3.33929 16C2.56949 17.3333 3.53174 19 5.07134 19Z"
                                    stroke="#D97706"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </div>
                        <div className={s.content}>
                            <h3>Proceed without adding all services?</h3>
                            <div className={s.des}>
                                Are you sure you want to proceed without adding all services? Providing more services
                                gives users more options to choose from and helps you stay competitive.
                            </div>
                            <div className={s.check}>
                                <Checkbox
                                    checked={hasCheckNotShow}
                                    onChange={(e) => {
                                        setHasCheckNotShow(e.target.checked);
                                    }}
                                >
                                    Don’t show this again
                                </Checkbox>
                            </div>
                        </div>
                    </div>
                    <div className={s.footer}>
                        <Button
                            onClick={() => {
                                setShowTipsModal(false);
                                setHasCheckNotShow(false);
                            }}
                        >
                            Back
                        </Button>
                        <Button
                            type="primary"
                            onClick={() => {
                                if (hasCheckNotShow) {
                                    setHasDisableViewServiceCheck('true');
                                }
                                setShowTipsModal(false);
                                handleSaveService();
                            }}
                            className={s.confirmBtn}
                        >
                            Proceed without adding services
                        </Button>
                    </div>
                </div>
            </Modal>
            <Modal
                okText="Set up single service sessions"
                onCancel={() => {
                    setShowWebinarModal(false);
                    // if (currentStep === EModalMode.CONFIG_PROGRAM_NOTE) {
                    //     setCurrentStep(EModalMode.CONFIG_SERVICE);
                    // }
                }}
                footer={
                    null && (
                        <div className={s.sModalFooter}>
                            <div className={s.sFooterAction}>
                                <Button
                                    onClick={() => {
                                        setShowWebinarModal(false);
                                        if (currentStep === EModalMode.CONFIG_PROGRAM_NOTE) {
                                            setCurrentStep(EModalMode.CONFIG_SERVICE);
                                        }
                                    }}
                                    type="primary"
                                >
                                    Set up single service sessions
                                </Button>
                            </div>
                        </div>
                    )
                }
                width={1100}
                className={`${commonS.modalFixHeightWrap} ${s.modalWrap}`}
                open={showWebinarModal}
                title="Discover more about the program in our next webinar"
            >
                <div className={s.sModalWrap}>
                    <div className={s.content}>
                        <div className={s.calendlyWrapOut}>
                            <div className={s.des}>
                                Interested in learning more before deciding? Join our next webinar to discover how the
                                Klarity Select Weight Loss Program can benefit your practice. Register now to secure
                                your spot!
                            </div>
                            <div id="calendly" className={s.calendlyWrap} />
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default ServiceLayer;
